import { render, staticRenderFns } from "./wdjs.vue?vue&type=template&id=2baeaf0e&scoped=true"
import script from "./wdjs.vue?vue&type=script&lang=js"
export * from "./wdjs.vue?vue&type=script&lang=js"
import style0 from "./wdjs.vue?vue&type=style&index=0&id=2baeaf0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baeaf0e",
  null
  
)

export default component.exports